import React, { useState } from "react";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import * as Modal from "../../../../../../common-deprecated/styles/v2/toyota/globals/Modal";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { BnbLabel } from "../../../utils/labels";
import * as Flex from "../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as Button from "../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Text from "../../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import * as PackStyles from "../step-customize/main-content/styles/Pack";
import Extra from "../common/extras/Extra";
import type { BuildAndBuyDispatchType } from "../../../redux/store";
import { resolveExtraConflicts } from "../../../redux/actions/BasketActions";
import type { ExtraConflictModalType } from "../../../utils/modalConstants";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";
import { useCommonLabel } from "../../../../../../common-deprecated/utils/commonLabels";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

const ExtraConflictModal = (props: ModalViewType<ExtraConflictModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const { extra, conflicts, extraPendingStack } = modalSettings;

    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const [selectedId, setSelectedId] = useState<string | null>(null);

    const commonLabel = useCommonLabel("close");

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="md">
            <Modal.Header>
                <Modal.Title>
                    <BnbLabel label="equipmentConflictTitle" />
                </Modal.Title>
                <Modal.Button type="button" aria-label={commonLabel} onClick={close}>
                    <IconWrapper aria-hidden="true">
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body>
                {conflicts && conflicts.length > 0 && (
                    <PackStyles.Grid>
                        {conflicts.map((item) => (
                            <Extra
                                key={item.id}
                                extra={item}
                                equipped={selectedId === item.id}
                                onSelect={() => {
                                    if (!selectedId || selectedId !== extra.id) setSelectedId(item.id);
                                    else setSelectedId(null);
                                }}
                                optional
                                enabled
                            />
                        ))}
                    </PackStyles.Grid>
                )}

                <Flex.Col display="flex" width="100%" justifyContent="flex-end" px={0} pt={3}>
                    <Button.Primary
                        m={0}
                        disabled={!selectedId}
                        onClick={() => {
                            const selectedExtra = conflicts.find((conflictExtra) => selectedId === conflictExtra.id);
                            if (selectedExtra) {
                                dispatch(resolveExtraConflicts(extra, selectedExtra, true, extraPendingStack));
                                close();
                            }
                        }}
                    >
                        {/* Reusing the pack conflict label here */}
                        <Text.Button>
                            <BnbLabel label="packConflictContinue" />
                        </Text.Button>
                    </Button.Primary>
                </Flex.Col>
            </Modal.Body>
        </ModalBaseView>
    );
};

export default ExtraConflictModal;
